import { createContext, useContext } from 'react'
import type { TourDefinition } from '../types'
import type { TourProgress } from '../types'

// Split out of TourProvider.tsx (rather than co-located there) so
// react-refresh/only-export-components doesn't flag that component file for
// exporting non-component values (the context object + this hook).

export interface TourContextShape {
  availableTours: TourDefinition[]
  progress: TourProgress
  startTour: (id: string) => void
  markCompleted: (id: string) => void
  resetProgress: () => void
  isFirstVisit: boolean
  userRole: string | null
}

export const TourContext = createContext<TourContextShape | null>(null)

export function useTourContext(): TourContextShape {
  const ctx = useContext(TourContext)
  if (!ctx) throw new Error('useTourContext must be used inside TourProvider')
  return ctx
}
